import styled from 'styled-components';

export const JargonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom:65px;
`;